import styled, { createGlobalStyle } from 'styled-components';
import { abyssColors } from '@/theme/colors';

interface GlobalStyleProps {
  scale: number;
  navbarHeight: number;
}

export const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html {
    font-size: 62.5%;
    zoom: ${(props) => props.scale};
  }

  :root {
    --zoom: ${(props) => props.scale};
  }

  body {
    padding: 0;
    margin: 0;
    font-family: "Roboto", sans-serif;
    font-optical-sizing: auto;
    font-weight: normal;
    font-style: normal;
    font-variation-settings: "wdth" 100;
    font-size: 1.6rem;
    overflow: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @media only screen and (max-width: 1728px) {
    html {
      font-size: 50%;
    }
  }

  *,
  ::before,
  ::after {
    box-sizing: border-box;
  }

  .PhotoView-Slider__BannerWrap {
    height: ${(props) => props.navbarHeight}px !important;
  }

  .PhotoView-Slider__toolbarIcon {
    display: none;
  }

  .PhotoView-Slider__Overlay {

    width: fit-content;
    z-index: 100;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  .aui-composer-input {
    font-size: 1.3rem;
  }

  .aui-thread-viewport {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .aui-thread-viewport::-webkit-scrollbar {
    display: none;
  }

  .aui-root {
    font-family: 'Roboto', sans-serif;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  }

  .aui-thread-welcome-center .aui-avatar-root {
    width: 5rem;
    height: 5rem;
    background: #E7EEF6;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .aui-avatar-root img {
    width: 3.2rem;
    height: 3.2rem;
  }

  .aui-avatar-root {
    width: 3.2rem;
    height: 3.2rem;
    background: #E7EEF6;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .aui-assistant-message-root .aui-avatar-root img {
    width: 2.8rem;
    height: 2.8rem;
  }


  .aui-modal-anchor{
    box-shadow: none;
  }

  .aui-thread-welcome-center {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
    text-align: center;
    font-size: 1.4rem;
    font-weight: 500;
  }

  .aui-user-message-root {
    font-size: 1.4rem;
  }

  .aui-assistant-message-root {
    font-size: 1.4rem;
  }

  .aui-thread-viewport {
    height: 465px;
  }

.custom-scrollbar::-webkit-scrollbar {
  height: 1.4rem;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: ${abyssColors.primary[100]};
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: ${abyssColors.primary[200]};
  border-radius: 1rem;
  border: 0.4rem solid ${abyssColors.primary[100]};
  cursor: grabbing;
}

// Hacky solution to disable pointer events for the html markers
// and allow clicking on POIs
// N.B: target div is the Billboard component of drei
#outer-viewer > div:not(:first-child) > div:first-child > div:first-child {
  pointer-events: none !important;
}
`;

const elevation2 = `'0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)'`;

export const ButtonLabel = styled.span`
  line-height: 22px;
  margin-bottom: -2px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const commonButtonStyle = {
  padding: '6px 16px',
  width: 'auto',
  height: '36px',
  lineHeight: 'normal',
  textTransform: 'none',
  fontSize: '1.3rem',
  '@media (max-width: 1728px)': {
    height: '28px',
    padding: '0px 8px',
    display: 'flex',
    alignItems: 'center',
  },
};

export const textButtonStyle = {
  ...commonButtonStyle,
  background: 'none',
  color: abyssColors.primary[500],
  boxShadow: 'none',
};

export const containedButtonStyle = {
  ...commonButtonStyle,
  background: abyssColors.primary[500],
  color: 'white',
  boxShadow: elevation2,
};
